export default function Overlay({ active, close }: { active: boolean, close: () => void }) {
  return (
    <div onClick={close} className={
      `fixed inset-0 bg-black/40 backdrop-blur-sm z-40
        transition-opacity duration-300
        ${active ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
    />
  );
}
